import { Grid2 } from "@mui/material";
import {
  AnnualProjectCapacity,
  TotalRevenue,
} from "../../../__generated__/types";
import {
  AnnualProjectCapacityLabels,
  TotalRevenueLabels,
} from "../../../utils";

const InfoItem = ({
  title,
  value,
}: {
  title: string;
  value: string | number;
}) => {
  return (
    <div>
      <p className="margin-0 font-size-3">
        <b>{title}</b>
      </p>
      <span className="font-size-4">{value}</span>
    </div>
  );
};

export const StaticBusinessGoals = ({
  numOfProjectsLastYear,
  totalRevenueLastYear,
  numOfProjectsThisYear,
  totalRevenueThisYear,
  largeScaleProjectCapacity,
  smallScaleProjectCapacity,
  currentChallenges,
  expectations,
}: {
  numOfProjectsLastYear: number;
  totalRevenueLastYear: TotalRevenue;
  numOfProjectsThisYear: number;
  totalRevenueThisYear: TotalRevenue;
  largeScaleProjectCapacity: AnnualProjectCapacity;
  smallScaleProjectCapacity: AnnualProjectCapacity;
  currentChallenges: string;
  expectations: string;
}) => {
  const spacing = 2;
  const topSectionSize = {
    xs: 12,
    sm: 6,
    lg: 3,
  };
  const bottomSectionSize = {
    xs: 12,
    md: 6,
  };
  return (
    <Grid2
      style={{ maxWidth: 980 }}
      container
      columns={12}
      columnSpacing={1}
      rowSpacing={3}
    >
      <Grid2
        size={topSectionSize}
        direction="row"
        spacing={spacing}
        alignItems="center"
      >
        <InfoItem
          title="Number of projects last year"
          value={numOfProjectsLastYear}
        />

        <InfoItem
          title="Total revenue last year"
          value={TotalRevenueLabels[totalRevenueLastYear]}
        />
      </Grid2>
      <Grid2
        size={topSectionSize}
        direction="row"
        spacing={spacing}
        alignItems="center"
      >
        <InfoItem
          title="Number of projects this year"
          value={numOfProjectsThisYear}
        />
        <InfoItem
          title="Total revenue this year"
          value={TotalRevenueLabels[totalRevenueThisYear]}
        />
      </Grid2>
      <Grid2
        size={topSectionSize}
        direction="row"
        spacing={spacing}
        alignItems="center"
      >
        <InfoItem
          title="Large scale project capacity"
          value={AnnualProjectCapacityLabels[largeScaleProjectCapacity]}
        />
        <InfoItem
          title="Small scale project capacity"
          value={AnnualProjectCapacityLabels[smallScaleProjectCapacity]}
        />
      </Grid2>
      <Grid2 size={bottomSectionSize}>
        <InfoItem title="Current challenges" value={currentChallenges} />
      </Grid2>
      <Grid2 size={bottomSectionSize}>
        <InfoItem title="Expectations" value={expectations} />
      </Grid2>
    </Grid2>
  );
};
